<section class="team-showcase-section section-padding">
  <div class="container">
    
    <div class="team-showcase-grid">

      <!-- Left Column: Executive Director Image Banner -->
      <div class="team-image-container">
        <div class="image-frame">
          <img src="/assets/images/hero_home.jpg" alt="Ambition Built Leadership Directors Sydney">
          <div class="image-overlay"></div>
          <div class="experience-badge">
            <span class="gold-dot"></span>
            <span>DIRECTOR LEVEL LEADERSHIP • 25+ YEARS EXPERIENCE</span>
          </div>
        </div>
      </div>

      <!-- Right Column: Leadership Narrative & Pillars -->
      <div class="team-info-container">
        <span class="subtitle">EXECUTIVE LEADERSHIP</span>
        <h2 class="title font-serif">THE PEOPLE BEHIND AMBITION BUILT</h2>
        <div class="gold-divider"></div>

        <p class="lead-text">
          A great home starts with an experienced, dedicated team. Our directors bring over 25 years of hands-on construction experience across Sydney, combining structural expertise with an unwavering passion for bespoke architectural homes.
        </p>

        <div class="leadership-pillars">
          <div class="pillar-item">
            <div class="pillar-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <div class="pillar-content">
              <h4>DIRECTOR-LED SITE SUPERVISION</h4>
              <p>Every home is personally managed and inspected on site by company directors to ensure flawless execution.</p>
            </div>
          </div>

          <div class="pillar-item">
            <div class="pillar-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
            </div>
            <div class="pillar-content">
              <h4>BESPOKE ARCHITECTURAL QUALITY</h4>
              <p>Uncompromising craftsmanship from engineering foundation pour down to custom timber joinery details.</p>
            </div>
          </div>

          <div class="pillar-item">
            <div class="pillar-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C5A265" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            </div>
            <div class="pillar-content">
              <h4>TRANSPARENT FIXED-PRICE CONTRACTS</h4>
              <p>Complete peace of mind with detailed specifications, clear milestones, and zero hidden surprises.</p>
            </div>
          </div>
        </div>

        <div class="action-wrap">
          <button (click)="meetTeamModal()" class="btn-gold">
            MEET OUR DIRECTORS &rarr;
          </button>
        </div>
      </div>

    </div>

  </div>
</section>